<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>لیست کاربران</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">

        <div v-if="isLoading" class="text-center">در حال بارگذاری...</div>
        <div v-else-if="error" class="text-danger text-center">{{ error }}</div>
        <div v-else class="table-responsive p-0">

          <div class="input-group mb-3">
            <span class="input-group-text" id="inputGroup-sizing-default">جستجو</span>
            <input type="text" class="form-control" aria-label="Sizing example input"
                   aria-describedby="inputGroup-sizing-default">
          </div>

          <table class="table align-items-center justify-content-center mb-0">
            <thead>
            <tr>
              <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                ردیف / #شناسه
              </th>
              <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                نام
              </th>
              <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                موبایل
              </th>
              <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                وضعیت
              </th>
              <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                آخرین فعالیت
              </th>
              <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                تاریخ بروزرسانی
              </th>
              <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                عملیات
              </th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(user,index) in users" :key="user.id">
              <td>
                <div class="d-flex px-2">
                  <h6 class="mb-0 text-sm">{{ index + 1 }} / #{{ user.id }}</h6>
                </div>
              </td>

              <td>
                <div class="d-flex px-2">
                  <div class="my-auto">
                    <h6 class="mb-0 text-sm">{{ user.first_name + ' ' + user.last_name }}</h6>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-sm font-weight-bold mb-0">{{ user.mobile }}</p>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{ user.status }}</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-xs font-weight-bold">1 روز پیش</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-xs font-weight-bold">{{ user.created_at }}</span>
              </td>
              <td class="align-middle d-flex justify-content-center">
                <router-link :to="'/dashboard/users/'+user.id" class="badge badge-success badge-sm"
                             data-toggle="tooltip"
                             data-original-title="Edit user">
                  مشاهده
                </router-link>

                <a href="javascript:;" class="badge badge-info badge-sm  me-2"
                   data-toggle="tooltip" data-original-title="Edit user">
                  ویرایش
                </a>
                <a href="javascript:;" class="badge badge-danger badge-sm me-2"
                   data-toggle="tooltip" data-original-title="Edit user">
                  حذف
                </a>

              </td>
            </tr>

            </tbody>
          </table>

          <!-- Pagination -->
          <nav v-if="pagination.links" class="mt-5" aria-label="Page navigation">
            <ul class="pagination justify-content-center">
              <li v-for="link in pagination.links" :key="link.label" class="page-item"
                  :class="{ active: link.active, disabled: !link.url }">
                <a class="page-link" href="javascript:;" @click.prevent="changePage(link.url)" v-html="link.label"></a>
              </li>
            </ul>
          </nav>

        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
    .page-item .page-link, .page-item span {
      width: 50px;
      height: 50px;
    }
</style>

<script setup>
import axios from 'axios';

import {ref} from 'vue';
import {onMounted} from 'vue';

const isLoading = ref(true);
const error = ref(null);
const users = ref([]);
const pagination = ref({});

const fetchUsers = async (page = 1) => {
  console.info(process.env)
  try {
    isLoading.value = true;
    const response = await axios.get(`${process.env.VUE_APP_API_URL}/users?page=` + page);
    let responseData = response.data.data;
    console.info('responseData', responseData);

    pagination.value = {
      current_page: responseData.current_page,
      last_page: responseData.last_page,
      links: responseData.links,
      next_page_url: responseData.next_page_url,
      prev_page_url: responseData.prev_page_url,
      total: responseData.total,
      per_page: responseData.per_page,
    };

    console.info('pagination', pagination);

    users.value = responseData.data; // Assuming the data is in the 'data' property
  } catch (err) {
    error.value = 'خطا در بارگذاری کاربران';
    console.error('Error fetching users:', err);
  } finally {
    isLoading.value = false;
  }
};

const changePage = (url) => {
  if (!url) return; // Skip if no URL (e.g., Previous/Next when disabled)
  const page = new URL(url).searchParams.get('page');
  fetchUsers(page);
};

onMounted(() => {
  fetchUsers();
});

// onBeforeMount(() => {
//
//   fetch('http://localhost:8000/api/users', {
//     method: 'GET',
//     // headers: {
//     //   'Content-Type': 'application/json',
//     //   'Accept': 'application/json'
//     // }
//   }).then(res => {
//     // Check if the response is ok (status in the range 200-299)
//     if (!res.ok) {
//       throw new Error('Network response was not ok: ' + res.statusText);
//     }
//     return res.json(); // Convert the response to JSON
//   })
//       .then(data => {
//
//
//         console.log('User data:', data); // Log the actual data
//
//         data = data.data; // Assuming the data is in the 'data' property
//
//         if (data) {
//           data.map(function () {
//
//           });
//         }
//       })
//       .catch(err => {
//         console.log('Catch error:', err); // Handle errors
//       });
//
// });

</script>

